<template>
  <div
    class="article-section"
    :id="domId"
    :class="{
      posted: section.disable_swiper || posted,
      'max-per-row-5': maxPerRow == 5
    }"
  >
    <div class="article-section__header">
      <div class="article-section__title" v-if="!section.hide_title">
        {{ section.title }}
      </div>
      <div class="article-section__subtitle">
        <a
          v-if="section.link"
          class="article-section__link"
          :href="section.link"
          target="_blank"
          >{{ section.link_text }}
        </a>
      </div>
    </div>
    <!-- rebuild -->
    <div class="rotator-wrapper" v-if="!section.disable_swiper">
      <ArrowButton :left="true" @click="swiperInstance.slidePrev()" />
      <swiper ref="instance" class="rotator" :options="swiperOption">
        <swiper-slide v-for="(article, index) in articles" :key="article.id">
          <Article
            :nextId="getId(index + 1)"
            :prevId="getId(index - 1)"
            :article="article"
            :rounded="rounded"
          />
        </swiper-slide>
      </swiper>
      <ArrowButton :left="false" @click="swiperInstance.slideNext()" />
    </div>
    <div class="no-swiper" :class="{ 'max-per-row-5': maxPerRow == 5 }" v-else>
      <div
        class="no-swiper-slide"
        v-for="(article, index) in articles"
        :key="article.id"
      >
        <Article
          :nextId="getId(index + 1)"
          :prevId="getId(index - 1)"
          :article="article"
          :rounded="rounded"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Article from "./ArticleSection/Article";

export default {
  name: "ArticleSection",
  components: { Article },
  props: {
    section: Object,
    rounded: {
      type: Boolean,
      default: () => false
    },
    maxPerRow: Number
  },
  data() {
    return {
      posted: false
    };
  },
  mounted() {
    console.info("mounted this.maxPerRow", this.maxPerRow);
    this.swiperInstance = this.$refs.instance.swiperInstance;

    if (location.hash.substring(1) == this.domId) {
      const y = this.$el.getBoundingClientRect().top + window.scrollY;
      window.scroll({
        top: y - 70,
        behavior: "smooth"
      });
    }

    let slideTo = -1;

    const { article_id } = this.$route.query;
    if (article_id) {
      slideTo = this.articles.findIndex(t => t.id == article_id);
    }

    if (slideTo == -1) {
      const lastPublished = this.articles
        .map(t => t.published)
        .lastIndexOf(true);
      if (lastPublished == -1) {
        if (this.articles[0]?.published) {
          slideTo = this.articles.length - 1;
        } else {
          slideTo = 0;
        }
      } else {
        slideTo = lastPublished;
      }
    }

    this.swiperInstance.slideTo(slideTo);

    if (this.section.start_at) {
      let until = Date.parse(this.section.start_at) - Date.now();
      if (until < 0) {
        this.posted = true;
      } else {
        this.posted = false;
        setTimeout(() => {
          this.posted = true;
        }, until);
      }
    } else {
      this.posted = true;
    }

    if (this.section.finish_at) {
      const until = Date.parse(this.section.finish_at) - Date.now();
      if (until < 0) {
        this.posted = false;
      } else {
        setTimeout(() => {
          this.posted = false;
        }, until);
      }
    }
  },
  methods: {
    getId(index) {
      const article = this.section.articles[index];
      return article?.posted ? article.id : null;
    }
  },
  computed: {
    articles() {
      return this.section.articles;
    },
    domId() {
      return this.section.title
        .toLowerCase()
        .split(" ")
        .join("-");
    },
    visibleControls() {
      const conditions = [
        this.$size == "sm" && this.section.articles.length > 2,
        this.$size == "md" && this.section.articles.length > 3,
        (this.$size == "lg" || this.$size == "xl") &&
          this.section.articles.length > 4
      ];

      return conditions.find(t => t);
    },
    swiperOption() {
      return {
        speed: 400,
        keyboard: {
          enabled: true
        },
        breakpoints: {
          0: {
            slidesPerView: 1.15,
            spaceBetween: 20
          },
          600: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          960: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1264: {
            slidesPerView: this.maxPerRow || 4,
            spaceBetween: 20
          }
        }
      };
    }
  }
};
</script>

<style scoped lang="scss">
.article-section {
  padding: 0 120px;
  margin-top: 35px;
  @media screen and (max-width: 960px) {
    padding: 0 20px;
  }
  @media screen and (max-width: 600px) {
    padding: 0;
    .arrow-button {
      visibility: hidden;
    }
  }

  &:not(.posted) {
    display: none;
  }

  &__title {
    font-weight: bold;
    font-size: 43px;
    line-height: 50px;
    text-transform: capitalize;
    margin: 0 56px 20px 0;
    color: $primary;
  }

  &__header {
    padding: 0px 40px 0px 0;
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
  }

  &__subtitle {
    margin-top: 0.25em;
    color: white;
    font-weight: 500;
    font-size: 22px;
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  a.article-section__link {
    font-weight: normal;
    margin-left: 30px;
    font-size: 18px;
    line-height: 24px;
    color: #1874dc;
    text-decoration: none;
    flex: 1;
  }

  .arrow-button {
    margin-top: -30px;
  }

  .max-per-row-5 {
    padding: 0;
  }
}

.no-swiper {
  display: flex;
  flex-wrap: wrap;
}

.no-swiper:not(.max-per-row-5) {
  .no-swiper-slide {
    flex-basis: 23.75%;
    margin-bottom: 2em;
    margin-right: 1.66%;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}

.no-swiper.max-per-row-5 {
  .no-swiper-slide {
    flex-basis: 18.672%;
    margin-bottom: 2em;
    margin-right: 1.66%;
    &:nth-child(5n) {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 1264px) {
  .no-swiper-slide {
    flex-basis: 31.84%;
    margin-right: 2.24%;
    &:nth-child(4n) {
      margin-right: 2.24%;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 960px) {
  .article-section {
    &__header {
      margin: 0 !important;
      padding-bottom: 20px;
    }
    a.article-section__link {
      margin-left: 20px;
    }

    &__title {
      margin: 5px 20px;
      font-size: 43px;
      line-height: 50px;
    }

    .no-swiper.max-per-row-5 {
      margin: 0 20px;
    }
  }

  .no-swiper {
    justify-content: space-between;
  }

  .no-swiper-slide,
  .no-swiper.max-per-row-5 .no-swiper-slide {
    flex-basis: 48%;
    margin-right: 0;
    padding-right: 0;
    &:nth-child(4n),
    &:nth-child(3n) {
      margin-right: 0;
      padding-right: 0;
    }
    &:nth-child(2n) {
      margin-right: 0;
      padding-right: 0;
    }
  }
}

@media screen and (max-width: 600px) {
  .article-section__header {
    padding: 0px 40px 20px 0;
  }

  .article-section {
    margin: 0;
    padding: 10px 0;
    .swiper-wrapper {
      padding: 0 0 0 9px;
    }
  }

  .swiper-container {
    overflow: visible;
  }

  .rotator-wrapper {
    margin-right: 20px;
    margin-left: 20px;
  }

  .no-swiper {
    flex-direction: row;
    flex-wrap: wrap;
    margin: 20px 0 0 20px;
    overflow: auto;
  }

  .no-swiper-slide,
  .no-swiper.max-per-row-5 .no-swiper-slide {
    flex-basis: 100%;
  }
}
</style>
